// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3HSAM","clinicsSelect":"TableHeading_clinicsSelect__1FV8m"};